import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import SessionModule from './session';
import { Settings } from '~/services/settings';
import EnrollmentModule from '~/store/enrollment';

export interface IEligibilityQuestions {
    surveySessionId: string;
    questionId: number;
    answerId: number;
}
@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    @Resolve
    public session!: SessionModule;

    @Resolve
    public enrollment!: EnrollmentModule;


    public eligibilityData = [] as SurveySessionValueModel[];

    public isEligible = false;

    @Mutation
    public async updateEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.eligibilityData) {
        this.eligibilityData = newEligibilityData;
    }

    @Mutation
    public addToOrUpdateEligibilityData(newItem: SurveySessionValueModel) {
        const searchItem = this.eligibilityData.filter(item => {
            if (item.questionId === newItem.questionId) return item;
            else return null;
        });
        const index = this.eligibilityData.indexOf(searchItem[0]);
        if (index > -1) {
            this.eligibilityData[index] = newItem;
        } else {
            this.eligibilityData.push(newItem);
        }
    }

    @Mutation
    public clearEligibilityQuestion(questionId: number) {
        const searchItem = this.eligibilityData.filter(item => {
            if (item.questionId === questionId) return item;
            else return null;
        });
        const index = this.eligibilityData.indexOf(searchItem[0]);
        if (index > -1) {
            this.eligibilityData.splice(index, 1);
        }
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    public async updateIsEligibleHCP(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Mutation
    public addOrUpdateEligibilityData(newItem: SurveySessionValueModel) {
        const searchItem = this.eligibilityData.filter(item => {
            if (item.questionId === newItem.questionId) return item;
            else return null;
        });
        const index = this.eligibilityData.indexOf(searchItem[0]);
        if (index > -1) {
            this.eligibilityData[index] = newItem;
        } else {
            this.eligibilityData.push(newItem);
        }
    }

    @Action({ rawError: true })
    public async clearStore() {
        this.updateEligibilityData([]);
        this.updateIsEligible(false);
        this.updateIsEligibleHCP(false);
    }


    @Action({ rawError: true })
    public checkEligibility(eligibilityData: SurveySessionValueModel[]): boolean {
        const correctAnswers = [
            +this.settings.eligibilityFederalAnswer,
            +this.settings.eligibilityCitizenAnswer,
            +this.settings.eligibilityAgeAnswer,
            +this.settings.pathPatientAnswer,
        ] as number[];

        const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
        this.updateIsEligible(isEligible);
        return isEligible;
    }

    @Action({ rawError: true })
    public checkEligibilityHCP(eligibilityData: SurveySessionValueModel[]): boolean {
        const correctAnswers = [
            +this.settings.eligibilityHCPFederalNo,
            +this.settings.eligibilityHCPCitizenYes,
            +this.settings.eligibilityHCPAgeYes,
            +this.settings.HCPpathHCPAnswer,
        ] as number[];

        const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
        this.updateIsEligibleHCP(isEligible);
        return isEligible;
    }
}
